import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import autobind from 'autobind-decorator';
import { RenderPropWithProps, RouteProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
// import { AppThunkDispatch } from '../../../common/types';
import { RootState } from '../../../base/RootReducer';

interface SurveyFollowupLayoutContainerState {
    name: string;
    email: string;
}

export interface SurveyFollowupLayoutProps extends SurveyFollowupLayoutContainerState {
    setLayoutState: (name: string, email: string) => void;
}

export interface SurveyFollowupLayoutContainerProps {
}

interface ReduxStateProps {
    isAuthenticated: boolean | null;
}

interface ReduxDispatchProps {
}

class SurveyFollowupLayoutContainer extends Component<
    SurveyFollowupLayoutContainerProps &
    TranslationFuncProp &
    RouteProps &
    RenderPropWithProps<SurveyFollowupLayoutProps> &
    ReduxStateProps &
    ReduxDispatchProps,
    SurveyFollowupLayoutContainerState
> {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        routeProps: PropTypes.any.isRequired,
        isAuthenticated: PropTypes.bool,
        location: PropTypes.object,
        //
        children: PropTypes.func.isRequired,
    };

    public readonly state = {
        name: '',
        email: '',
    };

    @autobind
    public setLayoutState(name: string, email: string) {
        this.setState(
            {
                name,
                email,
            });
    }

    public render() {
        return this.props.children({
            setLayoutState: this.setLayoutState,
            name: this.state.name,
            email: this.state.email,
        });
    }
}

const mapStateToProps = (store: RootState) => ({
    isAuthenticated: store.authState.isAuthenticated,
});

// const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({});

export default connect(mapStateToProps/*, mapDispatchToProps*/)(SurveyFollowupLayoutContainer);
